import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { isNullOrUndefined } from "util";
import { Router } from '@angular/router';
import { Settings } from '../Settings/settings';
import { Usuario } from "../Models/usuario/usuario";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public IsLogInOn= false;
  private api = Settings.urlAPi;
  public usuario:Usuario=new Usuario();
  constructor(private http:HttpClient, private router:Router) { }
  httpOption = {headers:new HttpHeaders({'Content-Type':'application/json'})}
 

  loginuser(usuario: string, clave: string): Observable<any> {
    let json = {'usuario':usuario,'clave':clave}
    return this.http.post<any>(Settings.urlAPi + 'usuario/select/lgin',json,this.httpOption);
  }

  setUser(user:any): void {
    this.usuario = user;
    //let user_string = JSON.stringify({'usuario':this.personal.login,'clave':this.personal.pwd});
    let user_string = JSON.stringify(this.usuario);
    localStorage.setItem("currentUser", user_string);
  }

  setToken(token): void {
    localStorage.setItem("accessToken", token);
  }

  getToken() {
    return localStorage.getItem("accessToken");
  }

  getCurrentUser(): any {
    let user_string = localStorage.getItem("currentUser");

    if (!isNullOrUndefined(user_string)) {
      let user = JSON.parse(user_string);
      
      return user;
    } else {
      return null;
    }
  }

  logoutUser() {
    let accessToken = localStorage.getItem("accessToken");
    //const url_api = `http://localhost:8000/api/Users/logout?access_token=${accessToken}`;
    localStorage.removeItem("accessToken");
    localStorage.removeItem("currentUser");
    //return this.http.post<any>(url_api, this.httpOption);
    this.router.navigateByUrl("/usuario/login");
  }
}
